export default "__VITE_ASSET__4ef77733__"